export default __webpack_public_path__ + "static/media/uploadinvoice.23245b23.svg";